import { call, put, takeLatest } from 'redux-saga/effects';

import * as types from './DashboardActionType';
import * as actions from './DashboardActions';
import * as dashboardService from './DashboardServices';

function* fetchDashboardDataSaga(action) {
    try {
        const response = yield call(dashboardService.getDashboardData, action.payload);
        yield put(actions.getDashboardDataSuccess(response.data));
    } catch (error) {
        yield put(actions.getDashboardDataFailure(error));
    }
}

function* fetchPortfolioDashboardSaga(action) {
    try {
        const response = yield call(dashboardService.getPortfolioDashboard, action.payload);
        yield put(actions.getPortfolioDashboardSuccess(response.data));
    } catch (error) {
        yield put(actions.getPortfolioDashboardFailure(error));
    }
}

export default function* watchDashboardSaga() {
    yield takeLatest(types.GET_DASHBOARD_DATA_REQUEST, fetchDashboardDataSaga);
    yield takeLatest(types.GET_PORTFOLIO_DASHBOARD_REQUEST, fetchPortfolioDashboardSaga);
}
